import React from 'react';
import { ActionButton, TooltipTrigger, Tooltip } from '@adobe/react-spectrum';
import { RevenueDriverIcon } from 'app/assets/legend/RevenueDriverIcon';

interface RevenueImpactIconProps {
  issueId: string;
  revenueImpact: boolean;
  openTooltip: string | null;
  setOpenTooltip: (value: string | null) => void;
  handleTooltipMouseEnter: (key: string) => void;
  handleTooltipMouseLeave: () => void;
  iconActionButtonClass: string;
  tooltipWrapperClass: string;
  isCompact?: boolean;
}

const RevenueImpactIcon: React.FC<RevenueImpactIconProps> = ({
  issueId,
  revenueImpact,
  openTooltip,
  setOpenTooltip,
  handleTooltipMouseEnter,
  handleTooltipMouseLeave,
  iconActionButtonClass,
  tooltipWrapperClass,
  isCompact = false
}) => {
  if (!revenueImpact) return null;

  const tooltipKey = isCompact ? 'revenue-driver' : 'revenue-impact-expanded';

  return (
    <TooltipTrigger
      isOpen={openTooltip === tooltipKey}
      onOpenChange={isOpen => {
        if (!isOpen) setOpenTooltip(null);
      }}
      placement="top"
    >
      <div
        className={tooltipWrapperClass}
        onMouseEnter={() => handleTooltipMouseEnter(tooltipKey)}
        onMouseLeave={handleTooltipMouseLeave}
      >
        <ActionButton
          data-testid={`timeline-card-${
            isCompact ? 'compact-' : ''
          }revenue-impact-${issueId}`}
          isQuiet
          UNSAFE_className={iconActionButtonClass}
          aria-label="Revenue Impact"
        >
          <RevenueDriverIcon width={16} height={18} />
        </ActionButton>
      </div>
      <Tooltip>Impacts Revenue Targets</Tooltip>
    </TooltipTrigger>
  );
};

export default React.memo(RevenueImpactIcon);
